// tslint:disable
export const de = {
  VerifyStatus: 'Status überprüfen',
  MarkAsDispensed: 'Als ABGABE ausbuchen',
  MarkAsSampled: 'Als PROBE ausbuchen',
  UndoDispense: 'Rückbuchung - ABGABE',
  UndoSample: 'Rückbuchung - PROBE',
  MarkAsDestroyed: 'Als VERNICHTET ausbuchen',

  Alert: 'Warnung',
  ErrorCode: 'Error Code',
  WarningFromNmvs: 'Warnung vom Nationalen Arzneimittelüberprüfungssystem für EPC',
  Reason: 'Grund',
  ContactAcknowledge: 'Kontaktieren Sie bitte ein Mitglied Ihrer Gruppe zum Bestätigen dieser Meldung.',
  Acknowledge: 'Bestätigen',
 
  CleanDateFormat: 'dd.mm.yyyy  h:MM:ss TT',
  ExpiryDateFormat: 'dd.mm.yyyy',
  ShortenedExpiryDateFormat: 'dd.mm.yyyy',

  ClearCompleted: 'List löschen',
  ManualEntry: 'Manueller Eintrag',

  FileName: 'Dateiname',
  Download: 'Herunterladen',
  ImvoPilotSetupInstructions: 'IMVO-Pilot Einrichtungsanweisungen',
  ZebraDevicesSetupInstructions: 'Zebra-Geräte Einrichtungsanweisungen',
  DataLogicGryphonGD4400: 'Datalogic Gryphon GD4400',
  DataLogicMagellan9800i: 'Datalogic Magellan 9800i',
  DataLogicMagellan3200VSI: 'Datalogic Magellan 3200 VSI',
  '232KeyConfiguration': '232Tastenkonfigurationseinstellung für Datalogic Magellan 3200 VSI',

  ProductDetails: 'Produktdetails',
  UserDetails: 'User details',
  ProductIdentification: 'Produktidentifikation',
  SerialNumber: 'Seriennummer',
  Expiry: 'Verfalldatum',
  LotNumber: 'Chargennummer',
  Status: 'Status',

  DeviceInfo: 'Device Info',
  UserProfile: 'Profile',
  Users: 'Benutzer',
  Settings: 'Einstellungen',
  Documentation: 'Dokumentation',
  Logout: 'Ausloggen',

  LoginErrorConnectivity: 'Sie müssen über eine Internetverbindung verfügen, wenn Sie sich das erste Mal einloggen.',
  SessionTimeout: 'Sitzungszeitüberschreitung.',
  InvalidUsernamePassword: 'Benutzername/Passwort ist ungültig.',
  Unauthorized: 'Unauthorized',
  TenantDoesNotExist: 'Klient existiert für ID nicht: ',
  Username: 'Benutzername',
  Password: 'Passwort',
  UsernameRequirement: 'Username must be between 5 and 50 characters',
  RetypePassword: 'Passwort bestätigen',
  Login: 'Einloggen',
  // todo: #30694 Add translations 
  FirstName: 'First Name',
  LastName: 'Last Name',
  ForgotPassword: 'Forgot password',
  ConfirmPasswordReset: 'Confirm Password Reset',
  ConfirmPasswordResetMessage: 'Are you sure you want to request a password reset for {{username}} ?',
  ResetPassword: 'Reset Password',
  PasswordResetSuccess: 'An email has been sent to the email address. Please follow the instructions in it to complete the password reset.',
  PasswordResetError: 'Error: could not send the password reset email. Please try again in a few minutes.',
  PasswordResetOfflineError: 'Error: You must be online to reset your password.',
  ForgotPasswordContactAdmin: 'Please contact your Active Directory administrator.',
  Email: 'Email',
  OtherActions: 'Other Actions',
  UserInfoWarning: 'Warning: Username, First Name, and Last Name cannot be changed after user creation.',

  ScannedDateTime: 'Scan Date/Time',
  NmvsResponseTime: 'NMVS Response Time',
  OptelResponseTime: 'Optel Response Time',
  TotalResponseTime: 'Total Response Time',
  Seconds: 'seconds',
  NotApplicable: 'N/A',

  Scan: 'Scannen',
  ScanOrTypeEpc: 'Den elektronischen Produktcode scannen oder eingeben',
  EnterEpcManually: 'Try manually entering the electronic product code',
  EpcScannedAuditMessage: '{{username}} scanned the EPC: {{epc}}, with Operation: {{operation}}',
  AlertAcknowledgedAuditMessage: 'Alert acknowledged by {{username}} for clientTransactionId: {{clientTransactionId}}',
  Pending: 'Offen',
  NotFound: 'Not Found',
  ProductCodeRequired: 'Ein Produktcode ist erforderlich.',
  SerialNumberRequired: 'Eine Seriennummer ist erforderlich.',
  BatchIdentifierRequired: 'Eine Chargennummer ist erforderlich.',
  ExpiryDateRequired: 'Ein Verfalldatum ist erforderlich.',
  UnprocessableEntity: 'Einheit kann nicht verarbeitet werden',
  
  DeviceId: 'Geräte-Identifikator',
  SystemInfo: 'Systeminformationen',
  Preferences: 'Benutzereinstellungen',
  Credentials: 'Anmeldedaten',
  Country: 'Land',
  Language: 'Sprache',
  LocationIdentifier: 'Identifikator-Ort',
  Certificate: 'Zertifizieren',
  CertificatePassword: 'Passwort zertifizieren',
  Processing: 'Wird verarbeitet...',
  Save: 'Speichern',
  CreateUser: 'Create User',
  Submit: 'Übermitteln',
  ClientId: 'Klient-ID eingeben',
  FileNullError: 'Ein Fehler ist beim Lesen der Datei aufgetreten.',
  InvalidFileError: 'Fehler: Datei muss mit .pfx oder .p12 enden',
  OfflineSettingsMessage: 'Sie können die Einstellungen im Offline-Modus nicht aktualisieren.',

  RegisterDevice: 'Register Device',
  UnregisterDevice: 'Unregister Device',
  UnregisterDeviceWarning: 'If you click this button, it will unregister this device from your location until the device is registered again.',
  
  Details: 'Details',
  User: 'Benutzer',
  Barcode: 'Strichcode',
  Pin: 'PIN',
  RetypePin: 'PIN bestätigen',
  Role: 'Rolle',
  ChangePIN: 'PIN ändern',
  ChangePassword: 'Passwort ändern',
  PasswordMatchError: 'Passwort stimmt nicht überein.',

  NoAvailableOperations: 'Für dieses Element sind keine Operationen verfügbar.',
  Verify: 'Überprüfen',
  TryVerifyAgain: 'Überprüfung erneut versuchen',
  Dispense: 'Abgabe',
  Sample: 'Probe',
  Destroy: 'Vernichten',
  Reintroduce: 'Wieder einführen',
  PleaseWait: 'Bitte warten...',
  ProductCode: 'Produktcode',
  AvailableOperations: 'Verfügbare Operationen',

  Cancel: 'Abbrechen',
  AddUser: 'Benutzer hinzufügen',
  EditUser: 'Benutzer bearbeiten',

  RoleTypeOptelAdmin: 'Optel-Admin',
  RoleTypeOptelSupport: 'Optel-Support',
  RoleTypeTenantAdmin: 'Mieter-Admin',
  RoleTypeOperator: 'Betreiber',
  RoleTypeViewer: 'Zuschauer',
  RoleTypeUnknown: 'Unbekannt',

  Back: 'Back',
  ActivateUser: 'Activate User',
  DeactivateUser: 'Deactivate User',
  DeleteUser: 'Benutzer löschen',
  Delete: 'Löschen',
  DeleteUserWarning: 'If you click this button, this user will be deleted permanently and it\s username won\'t be available anymore.',
  DeleteUserConfirmation: 'Sind Sie sicher, dass Sie löschen möchten {{username}} ?',
  Yes: 'Ja',
  No: 'Nein',
  ConfirmDeletion: 'Löschung bestätigen',
  Error: 'Fehler',
  CommunicationError: 'Ein Kommunikationsfehler ist mit dem Server aufgetreten. Klicken Sie, um es noch einmal zu versuchen.',
  SaveError: 'Ein Fehler ist beim Speichern aufgetreten. Versuchen Sie es bitte später noch einmal.',
  ClickTryAgain: 'Klicken Sie hier, um es noch einmal zu versuchen.',
  ClickErrorIconTryAgain: 'Click the error icon to try again.',
  
  LandingPageSloganPart1: 'AAC - Traceability Pilot for the Canadian Primary Aluminium Industry',
  LandingPageSloganPart2: '',
  FMDAcronym: 'FMD',
  EuropeanAcronym: 'EU',
  TermsAndConditions: 'Allgemeine Geschäftsbedingungen',
  AboutOptel: 'Über OPTEL Group',
  AllRightsReserved : 'Alle Rechte vorbehalten',
  OptelGroup: 'OPTEL Group',

  Online: 'Online',
  Offline: 'Offline',
  AwaitingConnection: 'Verbindung wird erwartet...',
  SimulateOffline: 'SimulateOffline',
  UndoOfflineWarning: 'Warnung: Im Offline-Modus ist die Rückbuchung-Funktion deaktiviert.',
  
  NothingToShow: 'Nichts anzuzeigen.',
  LoadingCerta: 'Certa wird geladen. Wenn dies länger als 10 Sekunden dauert, aktualisieren Sie die Seite bitte.',

  OptelTermsOfUseTitle: 'OPTEL-Nutzungsbedingungen',
  NmvsTermsOfUseTitle: 'NMVS-Nutzungsbedingungen',
  NmvsTermsOfUseWarning: 'Please Note: To be accepted by the location admin',
  Accept: 'Akzeptieren',
  Decline: 'Ablehnen',
  Ignore: 'Ignorieren',
  Dismiss: 'Entlassen',
  ClickHere: 'klick hier',

  MustAcceptTermsToLogin: 'Für die Anmeldung müssen Sie die Nutzungsbedingungen akzeptieren.',
  MustBeOnlineToAcceptTermsToLogin: 'Sie müssen über eine Online-Verbindung verfügen, um die Nutzungsbedingungen für die Anmeldung zu akzeptieren.',

  Austria: 'Österreich',
  Belgium: 'Belgien',
  Bulgaria: 'Bulgarien',
  Croatia: 'Kroatien',
  Cyprus: 'Zypern',
  CzechRepublic: 'Tschechische Republik',
  Denmark: 'Dänemark',
  Estonia: 'Estland',
  Finland: 'Finnland',
  France: 'Frankreich',
  Germany: 'Deutschland',
  Greece: 'Griechenland',
  Hungary: 'Ungarn',
  Iceland: 'Island',
  Ireland: 'Irland',
  Italy: 'Italien',
  Latvia: 'Lettland',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Litauen',
  Luxembourg: 'Luxemburg',
  Malta: 'Malta',
  Netherlands: 'Niederlande',
  Norway: 'Norwegen',
  Poland: 'Polen',
  Portugal: 'Portugal',
  Romania: 'Rumänien',
  Slovakia: 'Slowakei',
  Slovenia: 'Slowenien',
  Spain: 'Spanien',
  Sweden: 'Schweden',
  Switzerland: 'Schweiz',
  UnitedKingdom: 'Vereinigtes Königreich',
  
  UnableToParseEpc: 'Unable To Parse electronic product code.',
  UnderSizeError: 'Under Size Error',
  OverSizeError: 'Over Size Error',
  FixedSizeError: 'Fixed Size Error',
  NoSerializationData: 'No serialization data.',
  InvalidCheckDigit: 'Invalid check digit.',
  NoProductCodeForGtin: 'No product code was found for GTIN.',
  UrnFormatNotSupported: 'Urn format not supported.',
  InvalidSymbologyIdentifier: 'Invalid Symbology Identifier.',
  NoSymbologyIdentifier: 'No Symbology identifier.',
  CouldNotFindTypeInfo: 'Could not find a TypeInfo.',
  NullTypeInfo: 'TypeInfo cannot be null.',
  DigitsOnly: 'Digit only AI contains non-digit characters',
  CannotSerializeUnknownAi: 'Cannot serialize AI with unknown type.',
  CheckValueNotChar: 'Character must be a digit.',
  CheckValueTooBig: 'CheckValue cannot be greater than 9.',
  InvalidFormat: 'Invalid format.',
  CapsLockDetected: 'Scan has been blocked because the CAPSLOCK key is ON.',
  CapsLockSolution: 'Press the CAPSLOCK key on your keyboard then scan the code again.',
  ScanAttemptDetected: 'Ein Scan wurde erkannt, konnte jedoch nicht analysiert werden.',
  ScanAttemptSolution: 'Stellen Sie sicher, dass Ihr Scanner ordnungsgemäß konfiguriert ist, damit Opel es für die Verwendung der Certa-Anwendung benötigt.',
  Active: 'Active',
  FullName: 'Full Name',
  OnlineAssistance: 'Certa Online Assistance',
  UnknownErrorOccurred: 'An unknown error occurred in {{function}}.',
  SeparatorMissing: 'Missing GS separator character.',
  SeparatorSolution: 'Reconfigure your scanner and convert the GS character to a space or ^.',
  ScanCount: 'Scan Count',
  ProductName: 'Name',
  ConfirmUnregisterDeviceMessage: 'Are you sure that you want to unregister your device?',
  Confirm: 'Confirm'
};



// WEBPACK FOOTER //
// ./src/translations/translations.de.ts